function SearchBar({ setSearchBarShow, searchBarShow }) {
    return (
        <div className={`search-popup ${searchBarShow ? 'active' : ''}`}>
            <div onClick={() => setSearchBarShow(false)}
                className="search-popup__overlay search-toggler"
            ></div>
            <div className="search-popup__content">
                <form
                    onSubmit={e => {
                        e.preventDefault()
                        setSearchBarShow(false)
                    }}
                    role="search"
                    method="get"
                    className="search-popup__form"
                    action="#"
                >
                    <input type="text" id="search" placeholder="Qidiring..." />
                    <button type="submit" aria-label="search submit" className="eduhive-btn">
                        <i className="icon-search"></i>
                    </button>
                </form>
            </div>
        </div>
    )
}

export default SearchBar